import { render, staticRenderFns } from "./approvePayment_KSA.vue?vue&type=template&id=483d46c6&"
import script from "./approvePayment_KSA.vue?vue&type=script&lang=js&"
export * from "./approvePayment_KSA.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports